import { connect } from 'react-redux';

import { showModal } from '../../../../actions/ModalActions';
import * as checklistV2Actions from '../../../../actions/ChecklistV2Actions';
import * as checklistSelectors from '../../../../selectors/checklist/checklistSelectors';

import ChecklistNav from './ChecklistNav';

const mapStateToProps = state => ({
  invitePartnerViewActive: checklistSelectors.getPartnerDropdownState(state),
  filterParams: checklistV2Actions.getEncodedFilterQueryString(checklistSelectors.getTaskFilters(state)),
});

const mapDispatchToProps = dispatch => ({
  showSettingsModal: () => dispatch(showModal('CHECKLIST_EDIT')),
  onInvitePartnerToggle: () => dispatch(checklistV2Actions.toggleInvitePartnerView()),
  trackPrintChecklistClick: () => dispatch(checklistV2Actions.trackChecklistAction({ eventName: 'Print Checklist Clicked' })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChecklistNav);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistNav/index.js